import { AxiosResponse } from "axios";

import { API } from "../index";


export type SeatLayoutStatus = "draft" | "published" | "archived";

export type SeatLayoutPackageTier = {
  id?: number;
  client_key?: string;
  name: string;
  color: string;
  display_order: number;
};

export type SeatLayoutSeat = {
  id?: number;
  spot: number;
  spot_name?: string;
  layout_package?: number | null;
  layout_package_client_key?: string;
  label: string;
  seat_type: string;
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  display_order: number;
  is_active: boolean;
  meta?: Record<string, any> | null;
};

export type SeatLayoutDetail = {
  id: number;
  name: string;
  reservation_package: number;
  reservation_package_name: string;
  canvas_width: number;
  canvas_height: number;
  background_image_url: string;
  status: SeatLayoutStatus;
  version: number;
  published_at: string | null;
  packages: SeatLayoutPackageTier[];
  seats: SeatLayoutSeat[];
  created_at: string;
  updated_at: string;
};

export type SeatLayoutListItem = {
  id: number;
  name: string;
  reservation_package: number;
  reservation_package_name: string;
  canvas_width: number;
  canvas_height: number;
  background_image_url: string;
  status: SeatLayoutStatus;
  version: number;
  published_at: string | null;
  seat_count: number;
  updated_at: string;
};

export type PaginatedResponse<T> = {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
};

export type SeatLayoutPayload = {
  id?: number;
  name: string;
  reservation_package: number;
  canvas_width: number;
  canvas_height: number;
  background_image_url: string;
  packages: SeatLayoutPackageTier[];
  seats: SeatLayoutSeat[];
};

export type SeatLayoutBackgroundUploadResponse = {
  asset_url: string;
  asset_key: string;
};


const BASE = "/api/v2/seat-layouts/";


export const seatLayoutService = {
  list: (params?: Record<string, any>): Promise<AxiosResponse<PaginatedResponse<SeatLayoutListItem>>> =>
    API.get(BASE, { params }),

  get: (id: number): Promise<AxiosResponse<SeatLayoutDetail>> =>
    API.get(`${BASE}${id}/`),

  create: (payload: SeatLayoutPayload): Promise<AxiosResponse<SeatLayoutDetail>> =>
    API.post(BASE, payload),

  update: (id: number, payload: Partial<SeatLayoutPayload>): Promise<AxiosResponse<SeatLayoutDetail>> =>
    API.patch(`${BASE}${id}/`, payload),

  publish: (id: number): Promise<AxiosResponse<SeatLayoutDetail>> =>
    API.post(`${BASE}${id}/publish/`),

  duplicate: (id: number): Promise<AxiosResponse<SeatLayoutDetail>> =>
    API.post(`${BASE}${id}/duplicate/`),

  uploadBackgroundImage: (file: File): Promise<AxiosResponse<SeatLayoutBackgroundUploadResponse>> => {
    const formData = new FormData();
    formData.append("file", file);
    return API.post(`${BASE}upload-background-image/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  preview: (id: number, params: Record<string, any>): Promise<AxiosResponse<any>> =>
    API.get(`${BASE}${id}/preview/`, { params }),
};
